import { Outlet } from "react-router-dom";
import Sidebar from "../sidebar/sidebar";
import "./appLayout.css";

/*
 * AppLayout
 * ---------
 * The shell every role workspace uses: a fixed Sidebar on the left and the
 * routed page content on the right (via <Outlet/>).
 *
 * All role groups (admin/manager, funder, venture) share this single layout.
 * The Sidebar adapts its links automatically based on the signed-in user's
 * role, so there's no duplicated layout markup.
 */

export default function AppLayout() {
  return (
    <div className="appLayout">
      <Sidebar />
      <main className="appLayout-main">
        <div className="appLayout-content">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
